/* eslint-disable no-unused-vars */
const defaultConfig = {
  apiUrl: '',
  environment: 'DEVELOPMENT',
};

// class GlobalConfig {
//   config = defaultConfig;
// }

// export const globalConfig = new GlobalConfig();

// export const globalConfigUrl = 'config.json';

class GlobalConfig {
  constructor() {
    this.config = defaultConfig; // Assigner une valeur initiale comme en TypeScript
    this.notDefinedYet = true;
  }

  get() {
    if (this.notDefinedYet) {
      throw new Error('Global config has not been defined yet.');
    }
    else {
      return this.config;
    }
  }

  set(value) {
    if (this.notDefinedYet) {
      this.config = value;
      this.notDefinedYet = false;
    }
    else {
      throw new Error('Global config has already been defined');
    }
  }
}

export const globalConfig = new GlobalConfig();
export const globalConfigUrl = 'config.json';
